import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "header-menu" }
const _hoisted_2 = { class: "menu-list" }
const _hoisted_3 = ["onClick"]

import { baseUrl } from '@/utils';
import { ref, onMounted, watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const routeName = ref(route.name)

watchEffect(() => {
  routeName.value = route.name
  if (routeName.value == 'more') {
    routeName.value = 'home'
  }
})

const getClass = (data: any) => {
  let list = ['law', 'language', 'industryNews', 'medicalData', 'medicalRegister']
  let name = routeName.value || ''
  if (list.indexOf(name) > -1) {
    name = 'product'
  }
  return name == data.name ? 'active' : ''
}

const menuList = [
  {
    name: 'home',
    text: '首页'
  },
  {
    name: 'product',
    text: '产品服务'
  },
  {
    name: 'about',
    text: '公司介绍'
  },
  {
    name: 'contact',
    text: '联系我们'
  },
]

const changeMenu = (name: string) => {
  routeName.value = name
  router.push({ name })
}

onMounted(() => {
  if (routeName.value == 'more') {
    routeName.value = 'home'
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuList, (item, i) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["menu", getClass(item)]),
          key: i,
          onClick: ($event: any) => (changeMenu(item.name))
        }, _toDisplayString(item.text), 11, _hoisted_3)
      }), 64))
    ])
  ]))
}
}

})